import React, { useContext, useEffect, useState } from "react";   //FB 4409 DK - Added useeffect reference
import {
  Grid,
  Avatar,
  Typography,
  makeStyles,
  Link,
  CardMedia,
  CardContent,
  Card,
  Paper,
} from "@material-ui/core";
import doc from "../../../images/loc.jpg";
//import { Schedule, Provider } from "../../types";
import SlotsContainer from "./slotsByDateContainer";
import useStyle from "../css/styles";
import { Context } from "../store";
import globalsettings from "../../../config";
//FB 4774 DK - Added reference for formatphone method
import { formatphone, InsertPELogs } from "../api"; // FB 4960


// update log
// FB 4371 DK    03/29/2021    Added UI component to display the slots container
// FB 4409 DK    04/27/2021    Implementation of loading spinner on slots page
// FB 4409 DK    04/30/2021    Added message to show when all available slots are booked
// FB 4638 MS    08/31/2021    Fixed Mobile view issues
// FB 4774 DK    11/16/2021    Modified messages
// FB 4867 DK    01/20/2022    Phone number made clickable
// FB 4912 DK    01/27/2022    Resolved message error
// FB 4960 BR    07/03/2022   Logging all actions on PE
// FB 7413 GA    09/25/2023    Orady - Update the map link to the correct one
// FB 7908 SK    01/08/2024    PE Online Appointment Bookings Facility Missing Address 2
// FB 8142 SK    01/23/2024    Sophie - time slots are different when you go with by date vs. by provider flow
// FB 8213 MS    02/08/2024    Fetch the facility image from EMR
// FB 8290 MS    04/29/2024    Show google link only if available in EMR



export type Schedule = {
  ScheduleDate: string;
  Slots: string[];
};

export type SchedulesTest = {
  Facility_N: number;
  NextAvailability: string;
  SlotsDate: SlotsDate[];
};

export type SlotsDate = {
  ScheduleDate: string;
  Slots: string[];
};

export type Provider = {
  //name: string;
  //id: number;
  //facility: Facility;
  schedulesByDate: SchedulesByDate[];
};

export type SchedulesByDate = {
  Employee_N: number;
  Employee_First_Name: string;
  Employee_Last_Name: string;
  NextAvailability: string;
  availableSlotsCount: number;    //FB 4409 DK - Added variable for available slots count
  FacilityByDate: FacilityByDate[];
  Duration: number; //FB 4638 added duration field for ai response
};

export type FacilityByDate = {
  Facility_n: number;
  Facility_Name: string;
  Facility_Address: string;
  Facility_Address2: string;//FB 7908
  Facility_City: string;
  Facility_State: string;
  Facility_Zip: string;
  Slots: string[];
  SchedulinPhone: string;
  GOOGLE_MAPS_LINK: string //FB 7413 
};

interface IDateScheduleRowProps {
  Provider: Provider;
  FacilityByDate: FacilityByDate;
  Limited: number;
  indexNumber: number;
  Index: number;
  isLoading: any;   //FB 4409 DK - Added isLoading flag to activate loading spinner
}

const useStyles = makeStyles((theme) => ({
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  centered: {
    alignSelf: "center",
  },
  content: {
    flex: "1 0 auto",
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  topBarItem: {
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  margin: {
    margin: theme.spacing(1),
  },
  providerRow: {
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    padding: "20px 0",
  },
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    //width: "70%",
    cursor: "pointer",
    fontSize: "smaller",
    //height: "25px",
    "&:hover, &:focus": {
      backgroundColor: "#25aae1",
      color: "#fff",
    },
  },
  providerRowContainer: {
    overflowX: "auto",
    width: "70%",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "10px",
      backgroundColor: "lightgray",
    },

    "&::-webkit-scrollbar-thumb:horizontal": {
      backgroundColor: "rgba(0,0,0,.5)",
      //outline: '1px solid slategrey'
    },
  },
}));


function DateScheduleRow(props: IDateScheduleRowProps) {
  const classes = useStyles();
  const styles = useStyle();
  const { state, dispatch } = useContext(Context);
  //FB 4774 DK - Removed code since no longer needed
  const [disableEvents, setDiableEvents] = useState(false);

  //FB 4409 DK - Added flag for loading spinner
  const [isLoading, setIsLoading] = useState(false);
  const SchedulingPhone = formatphone(props.FacilityByDate.SchedulinPhone);   //FB-4867
  //FB 4960 Start
  const insertLogs = async () => {
    InsertPELogs(globalsettings.clientIp, "Click on View Map");
  }
  //FB 4960 End

  //FB 4409 DK - Added to swap the isLoading flag on slots page when isLoading flag is updated 
  useEffect(() => {
    props.isLoading(isLoading);
  }, [isLoading])

  //FB 8142 - Begin
  const [sessionAppointment, setSessionAppointment] = React.useState("");

  useEffect(() => {
    const appt = sessionStorage.getItem("AppointmentType");
    setSessionAppointment(appt!);
  }, []);
  //FB 8142 - End

  return props.FacilityByDate !== undefined ? (
    <div>
      {window.innerWidth <= 768 ? (
        <div>
          <Grid
            container
            spacing={3}
            direction="row"
            alignContent="center"
            justify="center"
          >
            <Grid item xs={12}>
              {state.appointmentdetails.appointmenttype === "telederm" ? (
                <Card
                  className={styles.slotspage_Card}
                  style={{ boxShadow: "none" }}
                >
                  <CardMedia style={{ marginTop: 15 }}>
                    {/* FB 8213 - changed src */}
                    <Avatar
                      className={styles.slotslocation_Avatar}
                      src={`${globalsettings.emrAPI}media/facilties/${props.FacilityByDate.Facility_n}.jpg`}
                    />
                  </CardMedia>
                  <CardContent>
                    <Typography variant="h6">
                      <b>{props.FacilityByDate.Facility_Name}</b>
                    </Typography>
                    <Typography>
                      {/* FB 4774 DK - Formatting the phone number with a generic method */}
                      {SchedulingPhone}   {/*FB-4867*/}
                    </Typography>
                  </CardContent>
                </Card>
              ) : (
                <Card
                  className={styles.slotspage_Card}
                  style={{ boxShadow: "none" }}
                >
                  <CardMedia style={{ marginTop: 15 }}>
                    {/* FB 8213 - changed src */}
                    <Avatar
                      className={styles.slotslocation_Avatar}
                      src={`${globalsettings.emrAPI}media/facilties/${props.FacilityByDate.Facility_n}.jpg`}
                    />
                  </CardMedia>
                  <CardContent>
                    <Typography variant="h6">
                      <b>{props.FacilityByDate.Facility_Name}</b>
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "medium",
                        display:
                          props.FacilityByDate.Facility_Address === "" ||
                            props.FacilityByDate.Facility_Address === null
                            ? "none"
                            : "block",
                      }}
                    >
                      {props.FacilityByDate.Facility_Address}
                    </Typography>
                    {/* FB 7908 - Begin */}
                    <Typography style={{ fontSize: "medium" }}>
                      {props.FacilityByDate.Facility_Address2 && (
                        props.FacilityByDate.Facility_Address2
                      )}
                    </Typography>
                    {/* FB 7908 - End */}
                    <Typography
                      style={{
                        fontSize: "medium",
                        display:
                          props.FacilityByDate.Facility_Address === "" ||
                            props.FacilityByDate.Facility_Address === null
                            ? "none"
                            : "block",
                      }}
                    >
                      {props.FacilityByDate.Facility_City},{" "}
                      {props.FacilityByDate.Facility_State},{" "}
                      {props.FacilityByDate.Facility_Zip}
                    </Typography>
                    <Typography>
                      {/* FB 4774 DK - Formatting the phone number with a generic method */}
                      {SchedulingPhone}   {/*FB-4867*/}
                    </Typography>
                    <Typography
                      style={{
                        display:
                          props.FacilityByDate.Facility_Address === "" ||
                            props.FacilityByDate.Facility_Address === null
                            ? "none"
                            : "block",
                      }}
                    >
                      <Link
                        href={
                          props.FacilityByDate.GOOGLE_MAPS_LINK
                        } //FB 7413
                        onClick={insertLogs} // FB 4960
                        target="_blank"
                        style={{
                          display:
                            props.FacilityByDate.GOOGLE_MAPS_LINK === "" ||
                              props.FacilityByDate.GOOGLE_MAPS_LINK === null
                              ? "none"
                              : "block",
                        }}  //FB 8290
                      >
                        View Map
                      </Link>
                    </Typography>
                    <Typography>{sessionAppointment}</Typography>{/* FB 8142 */}
                  </CardContent>
                </Card>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            direction="row"
            alignContent="center"
            justify="center"
            style={{
              display: "flex",
              pointerEvents: disableEvents ? "none" : "auto",
            }}
          >
            <Grid item xs={10} style={{ overflowX: "auto" }}>
              {props.FacilityByDate.Slots.length > 0 ? (
                <SlotsContainer
                  limited={1}
                  schedulesTest={props.FacilityByDate}
                  employeeName={
                    props.Provider.schedulesByDate[props.indexNumber]
                      .Employee_First_Name +
                    " " +
                    props.Provider.schedulesByDate[props.indexNumber]
                      .Employee_Last_Name
                  }
                  employeeid={
                    props.Provider.schedulesByDate[props.indexNumber].Employee_N
                  }
                  facilityid={props.FacilityByDate.Facility_n}
                  facilityName={props.FacilityByDate.Facility_Name}
                  facilityAddress={
                    props.FacilityByDate.Facility_Address +
                    ", " +
                    props.FacilityByDate.Facility_City +
                    ", " +
                    props.FacilityByDate.Facility_State +
                    ", " +
                    props.FacilityByDate.Facility_Zip
                  }
                  // FB 4774 DK - Formatting the phone number with a generic method
                  facilityPhone={SchedulingPhone}   //FB-4867
                  onCallback={setDiableEvents}
                  isLoading={setIsLoading}    //FB 4409 DK - Added to update the isLoading flag on slots page
                  duration={props.Provider.schedulesByDate[props.Index].Duration} //FB 4638 passing duration value
                />
                // FB 4409 DK - Added condition and message to be displayed when there are no available slots - Start
              ) : (props.Provider.schedulesByDate[props.indexNumber].availableSlotsCount <= 0 &&
                props.Provider.schedulesByDate[props.indexNumber].NextAvailability === null) ? (
                <Grid item style={{ margin: "auto" }}>
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                  >
                    <Paper
                      style={{
                        backgroundColor: "#EDEEEE",
                        borderRadius: "15px",
                        padding: 10,
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="subtitle2">
                        {/* FB 4774 DK - Modified message */}
                        {/*FB-4867*/}
                        There are no online appointments available for this date. Please call {SchedulingPhone} to book an appointment
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              ) : (
                // FB 4409 DK - Added condition and message to be displayed when there are no available slots - End
                <Grid item style={{ margin: "auto" }}>
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                  >
                    <Paper
                      style={{
                        backgroundColor: "#EDEEEE",
                        borderRadius: "15px",
                        padding: 10,
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="subtitle2">
                        {/* FB 4774 DK - Modified message */}
                        {/*FB-4867*/} {/*FB-4912*/}
                        The next available online appointment for this provider is  {props.Provider.schedulesByDate[props.indexNumber].NextAvailability}
                        . If you need an appointment sooner, Please call {SchedulingPhone}.
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </div>
      ) : (
        <div>
          <Grid
            container
            spacing={3}
            direction="row"
            alignContent="center"
            justify="flex-start"
            style={{
              borderBottom: "1px solid rgb(0 0 0 / 25%)",
              marginTop: 10,
            }}
          >
            <Grid item xs={4} sm={4} md={4}>
              {state.appointmentdetails.appointmenttype === "telederm" ? (
                <Card
                  className={styles.slotslocation_Card}
                  style={{ boxShadow: "none", alignItems: "center" }}
                >
                  <CardMedia style={{ marginTop: 15 }}>
                    {/* FB 8213 - changed src */}
                    <Avatar
                      className={styles.slotslocation_Avatar}
                      src={`${globalsettings.emrAPI}media/facilties/${props.FacilityByDate.Facility_n}.jpg`}
                    />
                  </CardMedia>
                  <CardContent style={{ display: "contents" }}>
                    <Typography variant="h6">
                      <b>{props.FacilityByDate.Facility_Name}</b>
                    </Typography>

                    <Typography>
                      {/* FB 4774 DK - Formatting the phone number with a generic method */}
                      {SchedulingPhone}   {/*FB-4867*/}
                    </Typography>
                  </CardContent>
                </Card>
              ) : (
                <Card
                  className={styles.slotslocation_Card}
                  style={{ boxShadow: "none", alignItems: "center" }}
                >
                  <CardMedia style={{ marginTop: 15 }}>
                    {/* FB 8213 - changed src */}
                    <Avatar
                      className={styles.slotslocation_Avatar}
                      src={`${globalsettings.emrAPI}media/facilties/${props.FacilityByDate.Facility_n}.jpg`}
                    />
                  </CardMedia>
                  <CardContent style={{ display: "contents" }}>
                    <Typography variant="h6">
                      <b>{props.FacilityByDate.Facility_Name}</b>
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "medium",
                        display:
                          props.FacilityByDate.Facility_Address === "" ||
                            props.FacilityByDate.Facility_Address === null
                            ? "none"
                            : "block",
                      }}
                    >
                      {props.FacilityByDate.Facility_Address}
                    </Typography>
                    {/* FB 7908 - Begin */}
                    <Typography style={{ fontSize: "medium" }}>
                      {props.FacilityByDate.Facility_Address2 && (
                        props.FacilityByDate.Facility_Address2
                      )}
                    </Typography>
                    {/* FB 7908 - End */}
                    <Typography
                      style={{
                        fontSize: "medium",
                        display:
                          props.FacilityByDate.Facility_Address === "" ||
                            props.FacilityByDate.Facility_Address === null
                            ? "none"
                            : "block",
                      }}
                    >
                      {props.FacilityByDate.Facility_City},{" "}
                      {props.FacilityByDate.Facility_State},{" "}
                      {props.FacilityByDate.Facility_Zip}
                    </Typography>
                    <Typography>
                      {/* FB 4774 DK - Formatting the phone number with a generic method */}
                      {SchedulingPhone}   {/*FB-4867*/}
                    </Typography>
                    <Typography
                      style={{
                        display:
                          props.FacilityByDate.Facility_Address === "" ||
                            props.FacilityByDate.Facility_Address === null
                            ? "none"
                            : "block",
                      }}
                    >
                      <Link
                        href={
                          props.FacilityByDate.GOOGLE_MAPS_LINK
                        } //FB 7413
                        onClick={insertLogs} //FB 4960
                        target="_blank"
                        style={{
                          display:
                            props.FacilityByDate.GOOGLE_MAPS_LINK === "" ||
                              props.FacilityByDate.GOOGLE_MAPS_LINK === null
                              ? "none"
                              : "block",
                        }}  //FB 8290
                      >
                        View Map
                      </Link>
                    </Typography>
                    <Typography>{sessionAppointment}</Typography>{/* FB 8142 */}
                  </CardContent>
                </Card>
              )}
            </Grid>
            <Grid
              item
              xs={6}
              sm={7}
              md={7}
              className={styles.byDateScrollbar}
              style={{
                display: "flex",
                overflowX: "auto",
                pointerEvents: disableEvents ? "none" : "auto",
              }}
              direction="row"
            //alignContent="space-around"
            //justify="space-around"
            >
              {props.FacilityByDate.Slots.length > 0 ? (
                <SlotsContainer
                  limited={1}
                  schedulesTest={props.FacilityByDate}
                  employeeName={
                    props.Provider.schedulesByDate[props.indexNumber]
                      .Employee_First_Name +
                    " " +
                    props.Provider.schedulesByDate[props.indexNumber]
                      .Employee_Last_Name
                  }
                  employeeid={
                    props.Provider.schedulesByDate[props.indexNumber].Employee_N
                  }
                  facilityid={props.FacilityByDate.Facility_n}
                  facilityName={props.FacilityByDate.Facility_Name}
                  facilityAddress={
                    props.FacilityByDate.Facility_Address +
                    ", " +
                    props.FacilityByDate.Facility_City +
                    ", " +
                    props.FacilityByDate.Facility_State +
                    ", " +
                    props.FacilityByDate.Facility_Zip
                  }
                  //FB 4774 DK - Formatting the phone number with a generic method
                  facilityPhone={SchedulingPhone}   //FB-4867
                  onCallback={setDiableEvents}
                  isLoading={setIsLoading}    //FB 4409 DK - Added to update the isLoading flag on slots page
                  duration={props.Provider.schedulesByDate[props.Index].Duration} //FB 4638 passing duration value

                />
              ) : (
                // FB 4409 DK - Added condition and message to be displayed when there are no available slots - Start
                props.Provider.schedulesByDate[props.indexNumber].availableSlotsCount <= 0 &&
                props.Provider.schedulesByDate[props.indexNumber].NextAvailability === null) ? (
                <Grid item style={{ margin: "auto" }}>
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                  >
                    <Paper
                      style={{
                        backgroundColor: "#EDEEEE",
                        borderRadius: "15px",
                        padding: 10,
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="subtitle2">
                        {/* FB 4774 DK - Modified message */}
                        {/*FB-4867*/}
                        There are no online appointments available for this date. Please call {SchedulingPhone} to book an appointment.
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              ) : (
                // FB 4409 DK - Added condition and message to be displayed when there are no available slots - End
                <Grid item style={{ margin: "auto" }}>
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                  >
                    <Paper
                      style={{
                        backgroundColor: "#EDEEEE",
                        borderRadius: "15px",
                        padding: 10,
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="subtitle2">
                        {/* FB 4774 DK - Modified message */}
                        {/*FB-4867*/} {/*FB-4912*/}
                        The next available online appointment for this provider is  {props.Provider.schedulesByDate[props.indexNumber].NextAvailability}
                        . If you need an appointment sooner, Please call {SchedulingPhone}.
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  ) : (
    <></>
  );
}
export default DateScheduleRow;
